import { Availability } from './availability';
import { TranslatedText, Translation } from './translated-text';

export class Category {
  id: string;
  categoryId: string;
  name: TranslatedText;
  order: number;
  products: any[];
  lastUpdated: Date;
  parent: string[] | number[];
  children?: string[] | number[];
  originalImageUrl?: string;
  imageUrl: string;
  currentImageUrlHash: string;
  availability: Availability[];
  isVisible: boolean;

  constructor(
    id: string,
    name: string | TranslatedText,
    order: number,
    products: any[],
    isVisible: boolean,
    originalImageUrl?: string,
    translations?: Translation[],
    children?: string[] | number[],
    availability?: Availability[],
    imageUrl?: string,
  ) {
    this.id = id;
    this.categoryId = id;
    this.name = typeof name === 'string' ? new TranslatedText(name) : name;
    this.order = order;
    this.products = products;
    this.lastUpdated = new Date();

    this.parent = [0];
    this.originalImageUrl = '';

    // Auxiliary fields for the image function
    this.imageUrl = imageUrl || '';
    this.currentImageUrlHash = '';

    this.availability = availability || [new Availability()];
    this.isVisible = isVisible;

    this.originalImageUrl = originalImageUrl;
    this.children = children;

    translations?.forEach(
      translation =>
        translation && this.name?.addTranslation(translation.language, translation.text),
    );
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
